module.exports = __webpack_public_path__ + "static/media/ss-vocab-new.ade953c9.gif";